import { types } from 'mobx-state-tree';

/*
  For now, we just use "string" in place of the decimal type implementation, converting to number just-in-time when we need a number.

  This deals with serializing and deserializing to/from string, as well as avoid floating-point errors.
  In the future, I might add a mobx-state-tree custom type for this.
*/
export const DecimalType = types.string